#import "../../../../common/graphql/EntityDocumentsFields.graphql"

query Supplier($id: UUID!) {
  supplier(id: $id) {
    id
    __typename
    _transactionQueryLevel
    _urgencyLevel
    _sortName
    vendorNumber
    federalTaxReference
    vatNumber
    supplierRatingResults {
      id
      countTotal
      starValue
      star1Percent
      star2Percent
      star3Percent
      star4Percent
      star5Percent
    }
    statusType {
      statusType
      approvalState
      _transactionIconStatus
    }
    _isUpdatable
    _isDeletable
    _rowTimestamp
    companyOrLastName
    firstName
    _isApproved
    _pendingApprovers
    customerAccount
    isIndividual
    isCorporation
    paymentTermTypeId
    isRelatedPartySupplier
    isCompetitiveBidsRequired
    isContractualPurchaseOrderRequired
    isEnvironmentalImpactTracked
    environmentalMetricId
    purchaseDocumentsPoolId
    bankAccountName
    bankRoutingNumber
    bankName
    bankSortCode
    bankIbanCode
    bankAccountNumber
    bankSwiftCode
    isDraft
    _isBankAccountVerified
    _isStagedApprovalRequest
    _isApprovalRevocable
    _fullName
    _isAliasOriginalNameViewable
    _isAliasInvoked
    vendorServiceTypeId
    vendorServiceRate
    vendorServiceType {
      isRateRequired
      isServiceRateAllowed
    }
    isW9OnFile
    w9ExpirationDate
    _isApprovalDocumentsRequired
    _requiredApprovalDocuments
    _isUpdateSupplierOverride
    supplierAddressesBySupplierId(orderBy: IS_PRIMARY_DESC) {
      nodes {
        id
        _rowTimestamp
        addressLine1
        addressLine2
        cityName
        countryId
        stateRegionId
        postalCode
        telephoneNumber
        emailAddress
        webAddress
        isSendEmailAccount
        isReceiveEmailAccount
        isPrimary
        stateRegion {
          stateRegion
          country {
            country
          }
          stateRegionDescription
        }
        country {
          country
        }
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
    supplierHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _rowTimestamp
      }
    }
    userMessagesByEntityId {
      totalCount
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    supplierContactsBySupplierId {
      nodes {
        id
        _rowTimestamp
        contactName
        emailAddress
        telephoneNumber
        isSendEmailAccount
        isReceiveEmailAccount
      }
    }
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
    approvalHistorySignaturesByEntityId(
      orderBy: SORT_ORDER_ASC
      filter: {
        not: {
          isApproved: { equalTo: false }
          isRejected: { equalTo: false }
          isRequested: { equalTo: false }
        }
      }
    ) {
      nodes {
        id
        additionalInformation
        digitalSignature
        actionDate
        isApproved
        isRejected
        isRequested
        userName
        entityDocumentId
        userOccupationTitle
        userSignatureDocument {
          id
          _downloadLink
          fileIndexInformation
          fileReference
          iconType
        }
      }
    }
  }
}
